import { useCallback, useState } from 'react';
import Cropper from 'react-easy-crop';
import { X } from 'lucide-react';
import { Button } from './ui/button';

// Overlay de recorte 16:9 travado, reaproveitado tanto pra imagem recém
// selecionada (criar/trocar imagem) quanto pra imagem já publicada, buscada
// via fetch() (ver handleAdjustExistingCrop em EventForm.js). Só devolve a
// área escolhida (em pixels) — quem chama decide o que fazer com ela.
export const ImageCropModal = ({ imageSrc, aspect = 16 / 9, onCancel, onConfirm }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [processing, setProcessing] = useState(false);

  const handleCropComplete = useCallback((_croppedArea, areaPixels) => {
    setCroppedAreaPixels(areaPixels);
  }, []);

  const handleConfirm = async () => {
    if (!croppedAreaPixels || processing) return;
    setProcessing(true);
    try {
      await onConfirm(croppedAreaPixels);
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[200] p-4">
      <div className="bg-card border border-border rounded-xl w-full max-w-lg overflow-hidden">
        <div className="flex items-center justify-between p-4 border-b border-border">
          <h3 className="font-semibold">Ajustar recorte (16:9)</h3>
          <Button variant="ghost" size="icon" type="button" onClick={onCancel} disabled={processing}>
            <X className="w-5 h-5" />
          </Button>
        </div>

        <div className="relative w-full h-80 bg-muted">
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={aspect}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={handleCropComplete}
          />
        </div>

        <div className="p-4 space-y-4">
          <div className="space-y-1">
            <label className="text-xs text-muted-foreground">Zoom</label>
            <input
              type="range"
              min={1}
              max={3}
              step={0.01}
              value={zoom}
              onChange={(e) => setZoom(Number(e.target.value))}
              className="w-full"
            />
          </div>
          <div className="flex gap-3">
            <Button type="button" variant="outline" className="flex-1" onClick={onCancel} disabled={processing}>
              Cancelar
            </Button>
            <Button type="button" className="flex-1" onClick={handleConfirm} disabled={processing || !croppedAreaPixels}>
              {processing ? 'Processando...' : 'Confirmar recorte'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
